import React from "react";
import CollectionExplorerSidebar from "../components/CollectionExplorerSidebar";
import ExplorerPageHeader from "../components/ExplorerPageHeader";
import EnterpriseExplorer from "../explorer/EnterpriseExplorer";

export default function ExplorerPage() {
  return (
    <div className="space-y-4">
      <ExplorerPageHeader />
      <div className="grid gap-4 lg:grid-cols-[280px_1fr]">
        <CollectionExplorerSidebar />
        <div className="min-w-0">
          <EnterpriseExplorer />
        </div>
      </div>
    </div>
  );
}
